
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("aWV53", function(module, exports) {

var $tTBSc = parcelRequire("tTBSc");
const $da1acb2a128ee65c$var$addDNSPrefetchLink = (url)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const linkElem = document.createElement('link');
    linkElem.rel = 'dns-prefetch';
    linkElem.href = url;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.getElementsByTagName('head')[0].appendChild(linkElem);
};
// `setupConnectJs` here is used to load ACJS globally,
// so that other Jira FE parts can use ACJS without `setupConnectJs`.
// This is not ideal because it's a bad practice to make other parts to think ACJS implicitly exists.
(0, $tTBSc.setupConnectJs)();
fetch('/rest/atlassian-connect/latest/addons-baseurl').then((response)=>response.ok ? response.json() : {})// @ts-expect-error - TS2339 - Property 'addonBaseUrls' does not exist on type '{}'. | TS2339 - Property 'addonBaseUrls' does not exist on type '{}'.
.then((json)=>json.addonBaseUrls && json.addonBaseUrls.forEach($da1acb2a128ee65c$var$addDNSPrefetchLink)).catch(()=>{});

});
parcelRegister("tTBSc", function(module, exports) {

$parcel$export(module.exports, "setupConnectJs", () => $c81546dab89b45de$export$891414b605e5f038);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $gjeS9 = parcelRequire("gjeS9");
var $4T9yL = parcelRequire("4T9yL");

var $4ayON = parcelRequire("4ayON");

const $c81546dab89b45de$var$installConnectJs = async ()=>{
    // we need the heritage to load in order for WRM core and jQuery to exist.
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $4T9yL.waitForHeritage)();
    await (0, $4ayON.waitForJQuery)();
    const loader = await (parcelRequire("gGHED"));
    await loader.performSideEffects();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.connectHost;
};
let $c81546dab89b45de$var$installConnectJsPromise = null;
const $c81546dab89b45de$export$891414b605e5f038 = async ()=>{
    // Only pages in the SPA will benefit from modernising connect
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__SPA__) {
        if ($c81546dab89b45de$var$installConnectJsPromise === null) $c81546dab89b45de$var$installConnectJsPromise = $c81546dab89b45de$var$installConnectJs();
        return $c81546dab89b45de$var$installConnectJsPromise;
    }
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $gjeS9.loadBridge)({
        name: 'ac/create',
        wrmKeys: [
            'wrc!com.atlassian.plugins.atlassian-connect-plugin:jira-atlassian-connect-resources-v5',
            // Undeclared Dependency: jira/navigation
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar'
        ]
    });
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.connectHost;
};

});
parcelRegister("gjeS9", function(module, exports) {

$parcel$export(module.exports, "loadBridge", () => $b5b36a00cf4f19d9$export$df8409da353bde5a);

var $ej5JA = parcelRequire("ej5JA");
var $1HTZw = parcelRequire("1HTZw");
var $agkbU = parcelRequire("agkbU");
var $97BGz = parcelRequire("97BGz");

var $agkbU = parcelRequire("agkbU");
var $97BGz = parcelRequire("97BGz");
var $iyT45 = parcelRequire("iyT45");
var $4T9yL = parcelRequire("4T9yL");
var $ligZL = parcelRequire("ligZL");
var $jb3ni = parcelRequire("jb3ni");
const $b5b36a00cf4f19d9$export$df8409da353bde5a = ({ name: name, wrmKeys: wrmKeys, tentatives: tentatives = (0, $ej5JA.MAX_RETRIES), timeout: timeout = (0, $ej5JA.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $ej5JA.SHOULD_LOG_ERROR) })=>{
    if (wrmKeys != null) return (0, $97BGz.loadBridgeStrict)({
        name: name,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        wrmKeys: [].concat(wrmKeys),
        shouldLogError: shouldLogError
    });
    if (tentatives <= 0) return Promise.reject(new Error('Unable to load bridge, zero tentatives never works'));
    if (tentatives <= 1) return (0, $1HTZw.loadBridgeBail)({
        name: name,
        shouldLogError: shouldLogError
    });
    return (0, $agkbU.loadBridgeRace)({
        name: name,
        shouldLogError: shouldLogError,
        timeout: (tentatives - 1) * timeout
    });
};

});
parcelRegister("ej5JA", function(module, exports) {

$parcel$export(module.exports, "safeErrorWithoutCustomerData", () => $98246445188fd0a7$export$f19a2d31722e3428);
$parcel$export(module.exports, "MAX_RETRIES", () => $98246445188fd0a7$export$1f86472c1374185a);
$parcel$export(module.exports, "DEFAULT_TIMEOUT", () => $98246445188fd0a7$export$7bd623b29ec8e1eb);
$parcel$export(module.exports, "SHOULD_LOG_ERROR", () => $98246445188fd0a7$export$37f20f0ff732fcd7);

var $eSnSE = parcelRequire("eSnSE");
const { safeErrorWithoutCustomerData: $98246445188fd0a7$export$f19a2d31722e3428, safeInfoWithoutCustomerData: $98246445188fd0a7$export$ea810ce67e3c8eac } = (0, $eSnSE.default);
const $98246445188fd0a7$export$1f86472c1374185a = 40;
const $98246445188fd0a7$export$7bd623b29ec8e1eb = 500;
const $98246445188fd0a7$export$37f20f0ff732fcd7 = true;

});

parcelRegister("1HTZw", function(module, exports) {

$parcel$export(module.exports, "loadBridgeBail", () => $d7bbb28cab06ad5d$export$a036f92c2465504e);

var $4Uno7 = parcelRequire("4Uno7");

var $ej5JA = parcelRequire("ej5JA");
const $d7bbb28cab06ad5d$export$a036f92c2465504e = async ({ name: name, shouldLogError: shouldLogError = (0, $ej5JA.SHOULD_LOG_ERROR) })=>{
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $ej5JA.safeErrorWithoutCustomerData)('common.bridge', `Unable to load bridge "${name}". ${(0, $4Uno7.safeStringify)(error) ?? ''}`, {
            isSpa: __SPA__,
            name: name,
            error: (0, $4Uno7.safeStringify)(error)
        });
        throw new Error(`Unable to load bridge "${name}"`, {
            cause: error
        });
    }
};

});
parcelRegister("4Uno7", function(module, exports) {

$parcel$export(module.exports, "safeStringify", () => $d05d3ad813870ea5$export$56831a8b9cb27763);
/**
 * Stringifies a JS object for logging.
 * @param object
 * @returns {string}
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d05d3ad813870ea5$export$56831a8b9cb27763 = (object)=>{
    if (!object) return '';
    if (object instanceof Error) return object.stack || object.message;
    return JSON.stringify(object, Object.getOwnPropertyNames(object));
};

});


parcelRegister("agkbU", function(module, exports) {

$parcel$export(module.exports, "loadBridgeRace", () => $224e973e4c93da11$export$20c32b4579d78b92);

var $1HTZw = parcelRequire("1HTZw");

var $iyT45 = parcelRequire("iyT45");

var $ej5JA = parcelRequire("ej5JA");
const $224e973e4c93da11$export$20c32b4579d78b92 = ({ name: name, timeout: timeout = (0, $ej5JA.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $ej5JA.SHOULD_LOG_ERROR) })=>Promise.race([
        (0, $iyT45.loadBridgeWeak)({
            name: name
        }),
        new Promise((resolve)=>setTimeout(resolve, timeout)).then(()=>(0, $1HTZw.loadBridgeBail)({
                name: name,
                shouldLogError: shouldLogError
            }))
    ]);

});
parcelRegister("iyT45", function(module, exports) {

$parcel$export(module.exports, "loadBridgeWeak", () => $f6004e9afa2128c3$export$3cefda82396756a1);

var $6M1XZ = parcelRequire("6M1XZ");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $f6004e9afa2128c3$var$pollingSingleton = null;
const $f6004e9afa2128c3$export$3cefda82396756a1 = ({ name: name })=>{
    const getter = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $f6004e9afa2128c3$var$pollingSingleton ?? (0, $6M1XZ.createPollingCollection)((v)=>window.require(v), 100);
    $f6004e9afa2128c3$var$pollingSingleton = getter;
    return getter(name);
};

});
parcelRegister("6M1XZ", function(module, exports) {

$parcel$export(module.exports, "createPollingCollection", () => $0a667df7ad6c937e$export$f163446a982a8077);

var $gRw8I = parcelRequire("gRw8I");

var $2oJXr = parcelRequire("2oJXr");
const $0a667df7ad6c937e$export$f163446a982a8077 = (fn, timeout)=>{
    (0, $gRw8I.di)(setTimeout);
    let isPolling = false;
    // Deferred instance is retained for polling
    const deferredMap = new Map();
    // Promise is derived from Deferred and is retained indefinitely
    const promiseMap = new Map();
    // Provided fn will throw until ready, once ready we will resolve and delete the Deferred
    const evaluateForKey = (key)=>{
        let result;
        try {
            result = fn(key);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return;
        }
        const deferred = deferredMap.get(key);
        if (deferred instanceof (0, $2oJXr.default)) {
            deferred.resolve(result);
            deferredMap.delete(key);
        }
    };
    const maybePoll = ()=>{
        if (!isPolling && deferredMap.size > 0) {
            isPolling = true;
            setTimeout(()=>{
                isPolling = false;
                [
                    ...deferredMap.keys()
                ].forEach(evaluateForKey);
                maybePoll();
            }, timeout);
        }
    };
    const getter = (key)=>{
        if (!promiseMap.has(key)) {
            const deferred = new (0, $2oJXr.default)();
            const promise = deferred.then((v)=>v);
            deferredMap.set(key, deferred);
            promiseMap.set(key, promise);
            evaluateForKey(key);
            maybePoll();
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return promiseMap.get(key);
    };
    return getter;
};

});
parcelRegister("2oJXr", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b7015c609345acf$export$2e2bcd8739ae039);
// @ts-expect-error - TS2417 - Class static side 'typeof Deferred' incorrectly extends base class static side '{ all<T>(values: Iterable<T | PromiseLike<T>>): Promise<Awaited<T>[]>; all<T extends readonly unknown[] | []>(values: T): Promise<{ -readonly [P in keyof T]: Awaited<T[P]>; }>; ... 5 more ...; readonly [Symbol.species]: PromiseConstructor; }'.
class $3b7015c609345acf$export$2e2bcd8739ae039 extends Promise {
    // go/jfe-eslint
    static resolve(v) {
        const instance = new $3b7015c609345acf$export$2e2bcd8739ae039();
        instance.resolve(v);
        return instance;
    }
    // go/jfe-eslint
    static reject(e) {
        const instance = new $3b7015c609345acf$export$2e2bcd8739ae039();
        instance.reject(e);
        return instance;
    }
    constructor(){
        // Promise.prototype.then() must be able to call new Deferred(fn)
        // @see https://stackoverflow.com/a/48159603
        // by using arguments flow will ensure we cannot instantiate with constructor parameters
        // eslint-disable-next-line prefer-rest-params
        const [fn] = Array.prototype.slice.call(arguments);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const callbacks = [];
        super(fn ?? callbacks.push.bind(callbacks));
        this.#resolve = callbacks[0];
        this.#reject = callbacks[1];
    }
    #resolve;
    #reject;
    resolve(v) {
        this.#resolve?.(v);
    }
    reject(e) {
        this.#reject?.(e);
    }
}

});




parcelRegister("97BGz", function(module, exports) {

$parcel$export(module.exports, "loadBridgeStrict", () => $32e00fb40c944769$export$eba600d28decc4ac);

var $bXaxC = parcelRequire("bXaxC");

var $agkbU = parcelRequire("agkbU");

var $7rBE0 = parcelRequire("7rBE0");

var $ej5JA = parcelRequire("ej5JA");
const $32e00fb40c944769$export$eba600d28decc4ac = async ({ name: name, wrmKeys: wrmKeys, shouldLogError: shouldLogError = (0, $ej5JA.SHOULD_LOG_ERROR) })=>{
    (0, $bXaxC.saveStats)(name, wrmKeys);
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        await (0, $7rBE0.loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError
        });
        return (0, $agkbU.loadBridgeRace)({
            name: name,
            shouldLogError: shouldLogError
        });
    }
};

});
parcelRegister("bXaxC", function(module, exports) {

$parcel$export(module.exports, "saveStats", () => $f1ca263307f66278$export$9ea3ff7978093559);
const $f1ca263307f66278$var$incrementResourceStats = (resource, stats)=>{
    if (stats[resource] == null) // eslint-disable-next-line no-param-reassign
    stats[resource] = 1;
    else // eslint-disable-next-line no-param-reassign
    stats[resource] += 1;
};
const $f1ca263307f66278$var$getEmptyLoadBridgeStats = ()=>({
        requests: 0,
        amdModules: {},
        wrmKeys: {}
    });
const $f1ca263307f66278$var$initStats = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__WRM_INTERNAL_STATS__ == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__ = {
        loadBridge: $f1ca263307f66278$var$getEmptyLoadBridgeStats()
    };
    else if (window.__WRM_INTERNAL_STATS__.loadBridge == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__.loadBridge = $f1ca263307f66278$var$getEmptyLoadBridgeStats();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WRM_INTERNAL_STATS__.loadBridge;
};
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $f1ca263307f66278$var$isPageInteractive = ()=>window.__WRM_INTERNAL_STATS__?.isPageInteractive;
const $f1ca263307f66278$export$9ea3ff7978093559 = (amdModuleName, wrmKeys)=>{
    try {
        const stats = $f1ca263307f66278$var$initStats();
        // stop accumulating stats at TTI mark
        if ($f1ca263307f66278$var$isPageInteractive()) return;
        stats.requests += 1;
        $f1ca263307f66278$var$incrementResourceStats(amdModuleName, stats.amdModules);
        if (Array.isArray(wrmKeys)) wrmKeys.forEach((wrmKey)=>$f1ca263307f66278$var$incrementResourceStats(wrmKey, stats.wrmKeys));
        else if (wrmKeys != null) $f1ca263307f66278$var$incrementResourceStats(wrmKeys, stats.wrmKeys);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // not critical functionality
    }
};

});

parcelRegister("7rBE0", function(module, exports) {

$parcel$export(module.exports, "loadWrmResources", () => $09f989d08b38b1cb$export$6cda16b6eff75f59);

var $4Uno7 = parcelRequire("4Uno7");

var $b6X3x = parcelRequire("b6X3x");

var $iyT45 = parcelRequire("iyT45");

var $ej5JA = parcelRequire("ej5JA");
const $09f989d08b38b1cb$export$6cda16b6eff75f59 = async ({ wrmKeys: wrmKeys, shouldLogError: shouldLogError, ...options })=>{
    const isPrefetch = 'batchUrl' in options;
    let newWrmKeys = wrmKeys;
    try {
        const name = isPrefetch ? 'wrm/require-v2' : 'wrm/require';
        const wrmRequireModule = await (0, $iyT45.loadBridgeWeak)({
            name: name
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const wrmRequire = isPrefetch ? wrmRequireModule.requireWithPrefetch : wrmRequireModule;
        // @ts-expect-error - TS2322 - Type 'string | string[]' is not assignable to type 'string[]'.
        newWrmKeys = (0, $b6X3x.prependSuperBatchDepsOnce)(wrmKeys);
        if (isPrefetch) return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys, options.batchUrl)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
        return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $ej5JA.safeErrorWithoutCustomerData)('common.bridge.wrm', 'Unable to load wrm resource', {
            isSpa: __SPA__,
            wrmKeys: JSON.stringify(newWrmKeys),
            error: (0, $4Uno7.safeStringify)(error)
        });
        throw new Error('Unable to load wrm resource', {
            cause: error
        });
    }
};

});
parcelRegister("b6X3x", function(module, exports) {

$parcel$export(module.exports, "prependSuperBatchDepsOnce", () => $aa5ee41b24db8c96$export$93d9db5fbabad1b0);

var $avFP5 = parcelRequire("avFP5");
let $aa5ee41b24db8c96$var$isSuperBatchDependenciesLoaded = false;
const $aa5ee41b24db8c96$var$isOnRapidBoardsPage = ()=>{
    const boardsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*[/]?$/;
    const backlogsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*\/backlog[/]?$/;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname } = window.location;
    return boardsRegex.test(pathname) || backlogsRegex.test(pathname) || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href.includes('secure/RapidBoard.jspa');
};
const $aa5ee41b24db8c96$export$93d9db5fbabad1b0 = (wrmKeys)=>{
    // These usually need injecting before most domain-specific deps but in rapidboards they load a
    // smaller set of the needed deps internally early and delay the rest
    if ($aa5ee41b24db8c96$var$isSuperBatchDependenciesLoaded || $aa5ee41b24db8c96$var$isOnRapidBoardsPage()) return wrmKeys;
    $aa5ee41b24db8c96$var$isSuperBatchDependenciesLoaded = true;
    return (0, $avFP5.jiraSuperBatchDependencies).concat(wrmKeys);
};

});
parcelRegister("avFP5", function(module, exports) {

$parcel$export(module.exports, "jiraSuperBatchDependencies", () => $00f9be664c96bf5d$export$f14a6b583ce9e077);
const $00f9be664c96bf5d$export$f14a6b583ce9e077 = [
    // SKATE HAS TO COME FIRST OR ELSE THE OTHER MODULES WILL FAIL
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:util-lite',
    'wrc!jira.webresources:util',
    'wrc!jira.webresources:feature-flags',
    'wrc!jira.webresources:dialogs',
    'wrc!jira.webresources:jira-global',
    'wrc!com.atlassian.auiplugin:aui-spinner'
];

});




parcelRegister("4T9yL", function(module, exports) {

$parcel$export(module.exports, "waitForHeritage", () => $ba1950b07a7f2989$export$c61060338d026f78);

var $hpZoI = parcelRequire("hpZoI");

var $2oJXr = parcelRequire("2oJXr");
const $ba1950b07a7f2989$export$c61060338d026f78 = ()=>{
    if (false) // WRM is not used on server
    // return null because we don't want to ?.then() chain into loadBridge functions
    return null;
    if (!__SPA__) // Heritage remainder is an SPA concept
    // return promise because we want to ?.then() chain into loadBridge functions
    return Promise.resolve();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!window.__WAIT_FOR_HERITAGE__) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WAIT_FOR_HERITAGE__ = new (0, $2oJXr.default)();
        (0, $hpZoI.bootstrapWrmClient)().then(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.__WAIT_FOR_HERITAGE__.resolve();
        });
    }
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WAIT_FOR_HERITAGE__;
};

});
parcelRegister("hpZoI", function(module, exports) {

$parcel$export(module.exports, "bootstrapWrmClient", () => $027e7c56f31b7541$export$d001f71dd306cb0c);

var $1Ozm9 = parcelRequire("1Ozm9");

var $4Uno7 = parcelRequire("4Uno7");

var $gYnSx = parcelRequire("gYnSx");
const $027e7c56f31b7541$var$SPA_WRM_CONTEXT_ENDPOINT = '/rest/frontend/1/spawrmcontext';
const $027e7c56f31b7541$var$fetchSpaWrmContext = async ()=>{
    return (0, $1Ozm9.default)($027e7c56f31b7541$var$SPA_WRM_CONTEXT_ENDPOINT);
};
const $027e7c56f31b7541$var$createResourceElement = ({ url: url, resourceType: resourceType, key: key, batchType: batchType })=>{
    let element;
    if (resourceType === 'JAVASCRIPT') {
        element = globalThis.document?.createElement('script');
        element.setAttribute('crossorigin', '');
        element.setAttribute('src', url);
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    } else {
        element = globalThis.document?.createElement('link');
        element.setAttribute('crossorigin', '');
        element.setAttribute('href', url);
        element.setAttribute('rel', 'stylesheet');
        element.setAttribute('media', 'all');
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    }
    return element;
};
let $027e7c56f31b7541$var$hasWrmInitialised;
const $027e7c56f31b7541$var$runBootstrap = ()=>{
    const spaWrmContext = $027e7c56f31b7541$var$fetchSpaWrmContext();
    return new Promise((resolve, reject)=>{
        spaWrmContext.then(({ data: data, errors: errors, resources: resources })=>{
            // eslint-disable-next-line no-multi-assign
            const WRM = globalThis.WRM = globalThis.WRM || {};
            WRM._unparsedData = data;
            WRM._unparsedErrors = errors;
            if (WRM._dataArrived) WRM._dataArrived();
            resources.map($027e7c56f31b7541$var$createResourceElement).forEach((element)=>globalThis.document?.head.appendChild(element));
            resolve();
        }).catch((error)=>{
            (0, $gYnSx.default)({
                error: new Error((0, $4Uno7.safeStringify)(error)),
                meta: {
                    id: 'bootstrap-wrm-client',
                    packageName: 'common-bridge',
                    teamName: 'jfp-magma'
                }
            });
            reject(new Error('Failed to fetch the spa wrm context'));
        });
    });
};
const $027e7c56f31b7541$export$d001f71dd306cb0c = ()=>{
    if (false) return Promise.resolve();
    if ($027e7c56f31b7541$var$hasWrmInitialised) return $027e7c56f31b7541$var$hasWrmInitialised;
    // todo maybe a more robust check to validate whether WRM initialisation already underway?
    if (typeof globalThis.WRM !== 'undefined') $027e7c56f31b7541$var$hasWrmInitialised = Promise.resolve();
    else $027e7c56f31b7541$var$hasWrmInitialised = $027e7c56f31b7541$var$runBootstrap();
    return $027e7c56f31b7541$var$hasWrmInitialised;
};

});


parcelRegister("ligZL", function(module, exports) {

$parcel$export(module.exports, "wrmRequire", () => $cfd4a2a9e13f6c24$export$cc9d8f51375ef66a);

var $7rBE0 = parcelRequire("7rBE0");

var $ej5JA = parcelRequire("ej5JA");
const $cfd4a2a9e13f6c24$export$cc9d8f51375ef66a = async (wrmKeys, shouldLogError = (0, $ej5JA.SHOULD_LOG_ERROR))=>(0, $7rBE0.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError
    });

});

parcelRegister("jb3ni", function(module, exports) {

$parcel$export(module.exports, "wrmRequireWithPrefetch", () => $4b0178a6bf26b876$export$e53a5db19a39ed2f);

var $7rBE0 = parcelRequire("7rBE0");

var $ej5JA = parcelRequire("ej5JA");
const $4b0178a6bf26b876$export$e53a5db19a39ed2f = async (wrmKeys, batchUrl, shouldLogError = (0, $ej5JA.SHOULD_LOG_ERROR))=>(0, $7rBE0.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError,
        batchUrl: batchUrl
    });

});


parcelRegister("4ayON", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $3de54a49c8727908$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "getJQuery", () => $3de54a49c8727908$export$7232a6dc780f9887);
$parcel$export(module.exports, "getGlobalAP", () => $3de54a49c8727908$export$fbc82125a6bd8012);
$parcel$export(module.exports, "isObject", () => $3de54a49c8727908$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "escapeSelector", () => $3de54a49c8727908$export$c8c0ea01c118c2eb);
$parcel$export(module.exports, "waitForJQuery", () => $3de54a49c8727908$export$97214de9c546981c);
$parcel$export(module.exports, "ErrorDebugAddonKeys", () => $3de54a49c8727908$export$d690da9bc8146677);

var $gYnSx = parcelRequire("gYnSx");

const $3de54a49c8727908$export$c47913ca32a5c6f7 = (key)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const metaTag = document.querySelector(`meta[name='ajs-${key}']`);
    return metaTag === null ? undefined : metaTag.getAttribute('content') || undefined;
};
const $3de54a49c8727908$export$7232a6dc780f9887 = ()=>AJS.$;
const $3de54a49c8727908$export$fbc82125a6bd8012 = ()=>// In the future, we can add analytics events to know how this can fail to access the global variable.
    // We can improve it to load WRM in async
    // Just to add some context for future reviewers: `window._AP` is the actual Connect module that will no longer be loaded via WRM.
    // Its properties are both appended from modules like the dialog options and the public @atlassian/atlassian-connect-js library.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window._AP;
const $3de54a49c8727908$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'function' || typeof obj === 'object' && !!obj;
const $3de54a49c8727908$export$c8c0ea01c118c2eb = (s)=>{
    if (!s) throw new Error('No selector to escape');
    return s.replace(/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g, '\\$&');
};
const $3de54a49c8727908$var$FIVE_MINUTES = 300000;
const $3de54a49c8727908$export$97214de9c546981c = ()=>new Promise((resolve, reject)=>{
        const interval = setInterval(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (window.AJS?.$) {
                clearInterval(interval);
                resolve();
            }
        }, 10);
        setTimeout(()=>{
            clearInterval(interval);
            (0, $gYnSx.default)({
                meta: {
                    id: 'connect-jquery-timeout',
                    packageName: 'jiraConnect'
                },
                error: new Error('Timeout when waiting for jQuery to be available on the page'),
                // this is an extremely common error, so we don't want to spam Sentry with it
                skipSentry: true
            });
            reject();
        }, $3de54a49c8727908$var$FIVE_MINUTES);
    });
const $3de54a49c8727908$export$7315c38dc71bd41f = 'com.atlassian.servicedesk.embedded-dev';
const $3de54a49c8727908$export$cb954c21735b28e4 = 'com.atlassian.servicedesk.embedded';
const $3de54a49c8727908$export$d690da9bc8146677 = [
    $3de54a49c8727908$export$cb954c21735b28e4,
    $3de54a49c8727908$export$7315c38dc71bd41f
];

});

parcelRegister("gGHED", function(module, exports) {

let $c2626e7263c90c87$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c2626e7263c90c87$var$load("kwvFG").then(()=>parcelRequire('jh0iZ'));

});




//# sourceMappingURL=async-connect-modules-new.8204bc8e.js.map
